import type { Template } from "@/types";

export const PO_03_H2_V1: Template[] = [
{
    id: "po-03-h2v2-01",
    name: "PO 01 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 0, y: 226, width: 450, height: 403, rotation: 0, imageRotation: 0 },
            { id: "2", x: 458, y: 226, width: 221, height: 403, rotation: 0, imageRotation: 0 },
            { id: "3", x: 686, y: 226, width: 450, height: 403, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-03-h2v2-02",
    name: "PO 02 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 50, y: 244, width: 410, height: 365, rotation: 0, imageRotation: 0 },
        { id: "2", x: 468, y: 244, width: 201, height: 365, rotation: 0, imageRotation: 0 },
        { id: "3", x: 677, y: 244, width: 408, height: 365, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-03",
    name: "PO 03 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 226, width: 449, height: 403, rotation: 0, imageRotation: 0 },
        { id: "2", x: 457, y: 226, width: 449, height: 403, rotation: 0, imageRotation: 0 },
        { id: "3", x: 914, y: 226, width: 222, height: 403, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-04",
    name: "PO 04 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 96, y: 159, width: 720, height: 534, rotation: 0, imageRotation: 0 },
        { id: "2", x: 824, y: 159, width: 216, height: 365, rotation: 0, imageRotation: 0 },
        { id: "3", x: 824, y: 532, width: 216, height: 161, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-05",
    name: "PO 05 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_05.png",
    size: [1136, 854],
    style: {},
    slots: [   
        { id: "1", x: 164, y: 103, width: 414, height: 320, rotation: 0, imageRotation: 0 },
        { id: "2", x: 164, y: 431, width: 414, height: 320, rotation: 0, imageRotation: 0 },
        { id: "3", x: 585, y: 103, width: 387, height: 648, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-06",
    name: "PO 06 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_06.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 77, y: 103, width: 414, height: 320, rotation: 0, imageRotation: 0 },
        { id: "2", x: 77, y: 431, width: 414, height: 320, rotation: 0, imageRotation: 0 },
        { id: "3", x: 659, y: 103, width: 386, height: 648, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-07",
    name: "PO 07 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_07.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 54, y: 67, width: 460, height: 357, rotation: 0, imageRotation: 0 },
        { id: "2", x: 54, y: 432, width: 460, height: 356, rotation: 0, imageRotation: 0 },
        { id: "3", x: 637, y: 67, width: 430, height: 721, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-08",
    name: "PO 08 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 91, y: 103, width: 386, height: 648, rotation: 0, imageRotation: 0 },
        { id: "2", x: 645, y: 103, width: 414, height: 320, rotation: 0, imageRotation: 0 },
        { id: "3", x: 645, y: 431, width: 414, height: 320, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h2v2-09",
    name: "PO 09 - H2V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h2_v1_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 226, width: 220, height: 403, rotation: 0, imageRotation: 0 },
        { id: "2", x: 228, y: 226, width: 450, height: 403, rotation: 0, imageRotation: 0 },
        { id: "3", x: 686, y: 226, width: 450, height: 403, rotation: 0, imageRotation: 0 }
    ],
}
];